import { atom } from "jotai";

interface NavState {
  toCompleteSupplyAgreement: { id: string } | null;
}

const initialState: NavState = {
  toCompleteSupplyAgreement: null,
};

export const navAtom = atom<NavState>(initialState);
